import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "ff_cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
    return undefined;
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="cookie-position"
          role="dialog"
          aria-label="Cookie consent"
          data-testid="cookie-banner"
        >
          <div className="card shadow-lift border border-slate-100 px-6 py-5 sm:px-8 sm:py-6 flex flex-col lg:flex-row lg:items-center gap-5">
            <div className="hidden sm:flex h-11 w-11 rounded-2xl bg-signal/10 items-center justify-center shrink-0">
              <Cookie className="h-5 w-5 text-corpblue" />
            </div>
            <div className="flex-1">
              <p className="font-display font-bold text-ink">We value your privacy</p>
              <p className="mt-1 text-sm text-slate-600 leading-relaxed">
                We use cookies to keep the site working, understand how it's used and improve your experience.{" "}
                <Link to="/privacy" data-testid="cookie-privacy-link" className="font-semibold text-corpblue hover:text-signal transition-colors">
                  Privacy Policy
                </Link>
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-2.5 shrink-0">
              <button
                onClick={() => decide("rejected")}
                data-testid="cookie-reject-button"
                className="btn-pill border border-ink/15 text-ink px-5 py-2.5 text-sm hover:border-signal hover:text-corpblue"
              >
                Reject All
              </button>
              <button
                onClick={() => decide("accepted")}
                data-testid="cookie-accept-button"
                className="btn-pill primary-action px-5 py-2.5 text-sm hover:shadow-glow"
              >
                Accept All Cookies
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
